import React, { createContext, useContext, useState } from 'react'

interface MenuContextProps {
  isCollapsed: boolean
  setCollapsed: (_collapsed: boolean) => void
  isHovered: boolean
  setHovered: (_hovered: boolean) => void
  isMenuVisible: boolean
  toggleMenu: (_visible: boolean) => void
}

export const MenuContext = createContext<MenuContextProps | undefined>(
  undefined,
)

export const MenuProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isCollapsed, setCollapsed] = useState(false)
  const [isHovered, setHovered] = useState(false)
  const [isMenuVisible, setIsMenuVisible] = useState(true)

  const toggleMenu = (visible: boolean) => {
    setIsMenuVisible(visible)
  }

  return (
    <MenuContext.Provider
      value={{
        isCollapsed,
        setCollapsed,
        isHovered,
        setHovered,
        isMenuVisible,
        toggleMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}

export const useMenu = (): MenuContextProps => {
  const context = useContext(MenuContext)
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider')
  }
  return context
}
